import { useCallback, useEffect, useState } from "react"
import { api, ApiError } from "../lib/api"
import type { MeResponse } from "../types"

interface UseMeResult {
  me: MeResponse | null
  loading: boolean
  error: string | null
  refetch: () => void
}

export function useMe(): UseMeResult {
  const [me, setMe] = useState<MeResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(() => {
    setLoading(true)
    setError(null)
    api
      .get<MeResponse>("/api/me")
      .then(setMe)
      .catch((e: unknown) => {
        setError(e instanceof ApiError ? e.message : "Erro ao carregar seus dados")
      })
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { me, loading, error, refetch: load }
}
